"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOYALTY_POINT_CONSTANT = void 0;
/**
 * By default, the ratio is set to 100 points to 100 cents. This value will not change.
 */
exports.LOYALTY_POINT_CONSTANT = 100;
//# sourceMappingURL=constants.js.map